import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import Toaddenterprise from '../toaddenterprise/toaddenterprise.vue'
import EnterpriseAccreditedRepository from '@/shared/http/repositories/realestate/enterpriseaccredited'
import { toast, loading } from '@/shared/utils/UIHelper'
export default {
  name: 'Tableenterprise',
  props: ['id', 'dataAll'],
  mixins: [ActionsForm],
  components: {HeadDetailsGama, Toaddenterprise},

  data () {
    return {
      head: ['EMPREENDIMENTO', 'ENDEREÇO', 'CIDADE', 'STATUS', 'TAMANHO', ''],
      credenciadaEmpre: []
    }
  },
  mounted () {
    this.getAllEnterpriseByAccredited()
  },
  methods: {
    openModal () {
      this.$refs['AbrirModal'].show()
    },
    getAllEnterpriseByAccredited () {
      EnterpriseAccreditedRepository.GetAllPaging(this.id, this.$refs.tableGrids.pagingLimit, this.$refs.tableGrids.pagingIndex)
        .then(Response => {
          this.credenciadaEmpre = Response.data.data
          this.$refs.tableGrids.LoadAllByData(Response)
        })
        .catch(() => {})
    },
    deleteEnterpriseAccredited (data) {
      EnterpriseAccreditedRepository.DeleteEnterpriseAccredited(data.id)
        .then(res => {
          if (res.status === 200) {
            toast.success(`Empreendimento excluido com sucesso`)
            this.dataAll.countEmpreendimento--
            loading.pop()
            this.$emit('update')
            this.getAllEnterpriseByAccredited()
          }
        })
        .catch(() => {
          toast.success(`Erro ao excluir o empreendimento`)
          loading.pop()
        })
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/tableenterprise/tableenterprise.js